import React, {useRef, useState} from "react";
import RestRequest from "../../tool/RestRequest";
import config from "../../config";
import {BasketCounter} from "../../service/BasketCounter";

export default function AddBasketLine({actions = {}, productId}) {

    function remove() {

        actions.setLoading('isLoading');

        RestRequest.delete(config.restBasket, productId).then(result => {
            if (result.data.status === 200) {
                BasketCounter.update();
                actions.remove(productId);
                actions.setLoading('');
            }

        });
    }

    return <a onClick={remove.bind(this)} className="basket-item-action-item" href="#">Удалить из корзины</a>;


}